import React, { Component } from 'react'
import { Container, Row, Col, Form } from 'react-bootstrap'

import emailjs from 'emailjs-com';
import apiKeys from '../apikeys'
import Footer from './Footer'
import HeaderTop from './HeaderTop'
import SideNavTop from './SideNavTop'
import '../Accueil.css'


class Contact extends Component {
  state = {
    redirect:false,
    search: ''
    }
  
  handleCHange = event => {
    const { name, value } = event.target
    this.setState({ [name]: value })
}

handleSubmit = event => {
  //on gere le form
  event.preventDefault()
  this.props.history.push(`/recherche/${this.state.search}`);
}

setRedirect = () => {
  this.setState({
    redirect: true
  })
}
  
handleSubmitFacebbok = () => {
  if (this.state.redirect) {
      window.location.href = "https://www.facebook.com/clubCAPN/";
  }
}

  sendEmail = (e) => {
    e.preventDefault();

    emailjs.sendForm('service_g4nxmka',apiKeys.TEMPLATE_ID, e.target, apiKeys.USER_ID)
    .then(result => {
      alert('Message Sent, I\'ll get back to you shortly');
      },
      error => {
      alert( 'An error occured, Please try again');
      })
  }

  render () {  
    return (
      <>
        <Container fluid>
        <Row>
            <SideNavTop/>
            <Col lg={10} md={12} sm={12} xs={12} id="page-content-wrapper" className="nopadding">
              <HeaderTop
                handleSubmit={this.handleSubmit}
                handleCHange={this.handleCHange}
                handleSubmitFacebbok={this.handleSubmitFacebbok}
                setRedirect={this.setRedirect}
              />

                  <Col lg={12} md={12} sm={12} xs={12} className="nopadding">
                    <Row>
                      <Col lg={12} md={12} sm={12} xs={12} className="nopadding">
                      <div className="contact-content">
                          <h1 className="hline"><span>Heures ouverture bureau et ligne téléphonique</span></h1>   
                          <p><i>Lundi: </i> FERMÉ<br />
                          <i>Mardi: </i>9h00 à 15h00<br />
                          <i>Mercredi: </i>9h00 à 15h00<br />
                          <i>Jeudi: </i>9h00 à 15h00<br />
                          <i>Vendredi: </i>FERMÉ<br />
                          <i>Samedi: </i>11h00 à 15h00<br />
                          <i>Dimanche:</i>8h30 à 15h30<br /></p> 
                      </div>

                      </Col>

                      <Col lg={12} md={12} sm={12} xs={12} className="nopadding">
                      <div className="contact-content">
                          <h1 className="hline"><span>Contact - Équipe de la direction</span></h1>   
                          <p><strong>Coordonnatrice aquatique: </strong>coordonatationcapn@gmail.com<br />
                          <strong>Natation-compétitif: </strong>infonatationcapn@gmail.com<br />
                          <strong>Sauvetage sportif: </strong>infosauvetage.capn@gmail.com<br />
                          <strong>Nage Synchronisé: </strong>synchrocapn@gmail.com<br />
                          <strong>Directrice Générale: </strong>srochelet.dgcapn@gmail.com<br />
                          <strong>Adjointe administrative: </strong>dgcapn@gmail.com<br /></p> 
                      </div>

                      </Col>

                      <Col lg={12} md={12} sm={12} xs={12} className="nopadding">
                      <div className="contact-content">
                            <h1 className="hline"><span>Contactez nous!</span></h1>    
                        <form className="contact-form" onSubmit={this.sendEmail}>
                          <Row>
                            <Col lg={6} md={6} sm={6} xs={12} className="nopadding">
                              <Form.Group>
                                <Form.Label>Nom *</Form.Label>
                                <Form.Control type="text" name="user_name" className="input-contact"required/>
                              </Form.Group>
                            </Col>
                            <Col lg={6} md={6} sm={6} xs={12} className="nopadding">
                              <Form.Group controlId="formBasicEmail">
                                <Form.Label>Courriel *</Form.Label>
                                <Form.Control type="email" name="user_email" className="input-contact"required/>
                              </Form.Group>
                            </Col>
                            <Col lg={6} md={6} sm={6} xs={12} className="nopadding">
                              <Form.Group>
                                <Form.Label>Message *</Form.Label>
                                <Form.Control as="textarea" rows={3} name="message" className="input-contact"required/>
                              </Form.Group>
                            </Col>
                            <Col lg={6} md={6} sm={6} xs={12} className="nopadding">
                            <Form.Group>
                              <Form.Control type="submit" value="Envoyer" className="button-contact"/>
                            </Form.Group>
                            </Col>
                          </Row>
                          </form>
                          </div>
                        </Col>

                        <Col lg={12} md={12} sm={12} xs={12} className="nopadding">

                          <div className="contact-content">
                            <h2><span><strong>Coordonnées</strong></span></h2>
                            <p><i>Lieu des activités</i><br />
                            10851 ave St-Charles,<br />
                            Montréal, Québec<br /><br />
                            <i>Adresse postale</i><br />
                            C.P 332 succursale Ahuntsic,<br />
                            Montréal, Québec,H3L 3N9<br /><br />
                            <i>Téléphone:</i> (514)385-1525<br />
                            <i>Courriel:</i> infos@clubcapn.com</p>

                          </div>
                          </Col>

                    </Row>
                  </Col>


              <Col lg={12} md={12} sm={12} xs={12} className="nopadding">
                <Footer />
              </Col>
            </Col>
          </Row>
        </Container>
      </>
    )
  }
  }

export default Contact
